import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    lock: false,
    status: 'idle',
    error: null,
};

const screenLockSlice = createSlice({
    name: 'lock',
    initialState,
    reducers: {
        reset: (state) => {
            return {
              ...state,
              lock: false,
              status: 'idle',
              error: null,
            }
        },
        setLock: (state, action) => {
            return {
              ...state,
              lock: action.payload,      // set last screen as current screen before changing
            }
        }
    },
});

export const { reset, setLock } = screenLockSlice.actions;
export const selectLock = state => state.lock.lock;

export default screenLockSlice.reducer;
